import { useEffect } from 'react';

// Injects a JSON-LD <script> into <head> under a unique id, and cleans it up on unmount.
export const useJsonLd = (id, schema) => {
  useEffect(() => {
    if (!schema) return undefined;
    let tag = document.getElementById(id);
    if (!tag) {
      tag = document.createElement('script');
      tag.id = id;
      tag.type = 'application/ld+json';
      document.head.appendChild(tag);
    }
    tag.textContent = JSON.stringify(schema);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, schema]);
};

export const SITE_URL = 'https://ineedasocialworker.com';
export const SITE_LOGO = 'https://ineedasocialworker.com/inasw-logo-crisp.png';
